const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'שעות עבודה',
        },
      },
    },
  },
};

export default layout;
